const accordions = [...document.querySelectorAll('.js-accordions')];

accordions.forEach(accordion => {
    const accordionItems = [...accordion.querySelectorAll('.js-accordions-item')];

    accordionItems.forEach(accordionItem => {
        const accordionToggle = accordionItem.querySelector('.js-accordions-toggler');

        accordionToggle.addEventListener('click', () => {
            accordionItems.forEach(item => {
                if (item !== accordionItem) {
                    item.removeAttribute('data-active');
                }
            });

            if (accordionItem.hasAttribute('data-active')) {
                accordionItem.removeAttribute('data-active');
            } else {
                accordionItem.setAttribute('data-active', '');

                // const offsetTop = accordionItem.getBoundingClientRect().top + window.pageYOffset - 100;
                //
                // window.scrollTo({
                //     top: offsetTop,
                //     behavior: 'smooth'
                // });
            }
        });
    });
});
